import store from "@/store";
export default {
  getFlags(tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/bookables/_meta/flags`, { withCredentials : true });
  }
};
